export default class SessionInvitation {
  constructor(API) {
    this.api = API;
  }
  /*
  {
    customerID: 'validString',
    tenantID: 'validString',
    courseID: 'validString',
    sessionID: 'validString',
    invitationCode: 'validString',
    useCount: 'number',
    maxUsage: 'number',
    createdBy: 'any?',
    updatedBy: 'any?',
    updatedOn: 'any?',
    createdOn: 'any?',
    transactionID: 'any?',
  }
  */
  async createSessionInvitation(sessionID, enrolmentInvitationObj) {
    const req = await this.api.newBaseRequest('POST');
    req.path = '/session/' + sessionID + '/invitation/new';
    req.body = enrolmentInvitationObj;
    return await req.exec();
  }
  async updateSessionInvitation(sessionID, invitationID, enrolmentInvitationObj) {
    const req = await this.api.newBaseRequest('PUT');
    req.path = '/session/' + sessionID + '/invitation/' + invitationID;
    req.body = enrolmentInvitationObj;
    return await req.exec();
  }
  async deleteSessionInvitation(sessionID, invitationID) {
    const req = await this.api.newBaseRequest('DELETE');
    req.path = '/session/' + sessionID + '/invitation/' + invitationID;
    return await req.exec();
  }
  async getSessionInvitation(sessionID, invitationID) {
    const req = await this.api.newBaseRequest('GET');
    req.path = '/session/' + sessionID + '/invitation/' + invitationID;
    return await req.exec();
  }
  async getSessionInvitationsBySessionID(sessionID) {
    const req = await this.api.newBaseRequest('GET');
    req.path = '/session/' + sessionID + '/invitations/';
    return await req.exec();
  }
  async validateSessionInvitation(invitationCode) {
    const req = await this.api.newBaseRequest('GET');
    req.path = '/session/invitation/validate/' + invitationCode;
    return await req.exec();
  }
}
